"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorTextColorIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="14" x="5" y="5" fill="currentcolor" fill-rule="evenodd" rx="2"/></svg>`
}, props));
EditorTextColorIcon.displayName = 'EditorTextColorIcon';
var _default = exports.default = EditorTextColorIcon;